
import React from "react";
import { useTranslation } from "react-i18next";

const SelectTimeTitle: React.FC = () => {
  const { t } = useTranslation('booking');
  return (
    <h1 className="text-3xl sm:text-4xl font-display mb-3 text-center">
      {t('TIME_TITLE')}
    </h1>
  );
};

export default React.memo(SelectTimeTitle);
